import { render } from "./Sequences.vue?vue&type=template&id=4d485ce5"
import script from "./Sequences.vue?vue&type=script&lang=js"
export * from "./Sequences.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__